import { createContext, useState } from 'react'
import PropTypes from 'prop-types'

export const PrintContext = createContext()

const PrintProvider = (props) => {
  const { children } = props

  const [currentPage, setCurrentPage] = useState(null)
  const [fetchPrintData, setFetchPrintData] = useState(false)
  const [printDataFetched, setPrintDataFetched] = useState(false)
  const [showFallBack, setShowFallBack] = useState(false)

  return (
    <PrintContext.Provider
      value={{
        currentPage,
        setCurrentPage,
        fetchPrintData,
        setFetchPrintData,
        printDataFetched,
        setPrintDataFetched,
        showFallBack,
        setShowFallBack
      }}
    >
      {children}
    </PrintContext.Provider>
  )
}

PrintProvider.propTypes = {
  children: PropTypes.object
}

export default PrintProvider
